import React from 'react'

import assetUrl from 'src/utils/assetUrl'

const logo = assetUrl(RAILS_ASSET_URL('/logo.svg'))

const Footer = ({ footer }) =>
  <footer className="footer">
    powered by
    <a href={footer.url} target="_blank" className="ms-1">
      <img
        src={logo}
        alt="Pledge"
        className="footer-logo"
        style={{ height: '1.25rem' }}
      />
    </a>
  </footer>

export default Footer
